import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const FiltersIcon = createIcon({
  displayName: 'FiltersIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g
        xmlns="http://www.w3.org/2000/svg"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      >
        <path d="M18 5h3" />
        <path d="M3 5h11" />
        <path d="M10 12h11" />
        <path d="M3 12h3" />
        <path d="M18 19h3" />
        <path d="M3 19h11" />
        <path d="M17.4142 3.58579c.781049.781049.781049 2.04738 0 2.82843 -.781049.781049-2.04738.781049-2.82843 0 -.781049-.781049-.781049-2.04738 0-2.82843 .781049-.781049 2.04738-.781049 2.82843-4.44089e-16" />
        <path d="M9.41421 10.5858c.781049.781049.781049 2.04738 0 2.82843 -.781049.781049-2.04738.781049-2.82843 0 -.781049-.781049-.781049-2.04738-8.88178e-16-2.82843 .781049-.781049 2.04738-.781049 2.82843 0" />
        <path d="M17.4142 17.5858c.781049.781049.781049 2.04738 0 2.82843 -.781049.781049-2.04738.781049-2.82843 0 -.781049-.781049-.781049-2.04738 0-2.82843 .781049-.781049 2.04738-.781049 2.82843 0" />
      </g>
      <path xmlns="http://www.w3.org/2000/svg" fill="none" d="M0 0h24v24h-24Z" />
    </>
  ),
})

const Filters: FC<IconProps> = (props) => {
  return <CustomIcon as={FiltersIcon} {...props} />
}

export default memo(Filters)
